let counter = {};

counter.state = 100;

counter.getFreshInteger = (n) => {
  counter.state++;
  if (n > counter.state || n === counter.state) {
    counter.state = n + 1;
  }
  return counter.state;
  // return counter.state.toString();
};

export default counter;